import { render, staticRenderFns } from "./MyQuery.vue?vue&type=template&id=12bfafae&"
import script from "./MyQuery.vue?vue&type=script&lang=js&"
export * from "./MyQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports